export enum TermStatus {
  BEFORE_OPEN = 0, // 手本公開前
  PRE_OPEN = 1, // 手本公開中(課題受付前)
  NOW_OPEN = 2, // 課題受付中
  CLOSED = 3, // 課題受付終了
}
